<template>
  <div class="mb_controller bg">
    <div class="container-fluid px-0 min-height-for-section">
      <div class="w-100 d-flex flex-column align-content-between">
        <div>
          <div
            v-if="mobile"
            class="w-100 d-flex d-md-none flex-column radio-mobile-container"
          >
            <div class="radio-mobile-player">
              <RadioPlayerFull :id="playerId" :type="'audio'" />
            </div>
          </div>
          <div
            v-if="desktop || tablet"
            class="w-100 d-block position-relative pb-4"
          >
            <RadioMainCarousel :active_id="currentid" v-if="currentid" />
          </div>
          <div class="row mt-5 mx-0">
            <div class="col-12">
              <HomepageRadio :active_id="currentid" />
            </div>
          </div>

          <div class="w-100 mt-5">
            <div class="col-12">
              <!-- ads -->
              <BillboardBannerBottom v-if="desktop"></BillboardBannerBottom>
              <MrecBannerBottom v-if="mobile"></MrecBannerBottom>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import RadioMainCarousel from "@/components/carousel/radio/radioMainCarousel";
import HomepageRadio from "@/components/carousel/radio/homepageRadio.vue";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
import RadioPlayerFull from "@/components/players/radioPlayerFull.vue";
import BillboardBannerBottom from "../components/ads/v2/radio/billboardBannerBottom.vue";
import MrecBannerBottom from "../components/ads/v2/radio/mrecBannerBottom.vue";
import axios from "axios";
export default {
  components: {
    RadioMainCarousel,
    HomepageRadio,
    BreadCrumbsHeader,
    RadioPlayerFull,
    BillboardBannerBottom,
    MrecBannerBottom,
  },
  data: function() {
    return {
      id: this.$route.params.id,
      currentid: 0,
      playerId: 0,
      radio: [],
      tablet: false,
      mobile: false,
      desktop: false,
    };
  },
  beforeMount() {
    this.deviceCheck();
    this.initializeContentForStart();
  },
  mounted() {
    if (!this.$route.params.id) {
      setTimeout(
        function() {
          this.initializecontentview();
          this.initializepageview();
        }.bind(this),
        700
      );
    }
  },
  beforeDestroy() {
    this.destroyRadioPlayers();
  },
  beforeRouteLeave(to, from, next) {
    this.destroyRadioPlayers();
    next();
  },
  methods: {
    destroyRadioPlayers() {
      const player = window.gluePlayer;

      if (player) {
        try {
          if (typeof player.destroy === "function") {
            player.destroy();
          } else if (typeof player.stop === "function") {
            player.stop();
          } else if (typeof player.pause === "function") {
            player.pause();
          }
        } catch (e) {
          console.log(e);
        }
      }

      if (this.$el) {
        const nodes = this.$el.querySelectorAll(
          ".radio-mobile-player .player, .playerAbsolute .player"
        );
        nodes.forEach((node) => {
          node.innerHTML = "";
        });
      }

      window.gluePlayer = null;
    },
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
    filterOtherFolderData(obj) {
      this.radio.push(obj);
      this.currentid = obj[0].id;
    },
    async getRadioData() {
      try {
        axios
          .get(`https://rtb.glueapi.io/v1/content?idSchema=202&format=json`)
          .then((response) => {
            var radio_order = [4, 7, 6, 3, 5];

            var data = response.data.data;

            data.sort(function(a, b) {
              return radio_order.indexOf(a.id) - radio_order.indexOf(b.id);
            });

            this.filterOtherFolderData(data);
          });
      } catch (e) {
        console.log(e);
      }
    },
    initializecontentview() {
      var self = this;
      var token = localStorage.getItem("token");
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/viewed",
        contentType: "application/json; charset=utf-8",
        headers: {
          "X-AUTH-TOKEN": `${token}`,
        },
        data: JSON.stringify({
          idContent: self.currentid, // Content ID from content api response
          contentTitle: self.$route.path, // Content Longtitle from content api response
          site: "RTBGo",
          dbLogging: 1,
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    initializepageview() {
      var self = this;
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: self.$route.path,
          title: "radio",
          site: "RTBGo",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    initializeContentForStart() {
      var vm = this;
      if (vm.id) {
        setTimeout(
          function() {
            Vue.nextTick(
              function() {
                vm.playerId = vm.id;
              }.bind(vm)
            );
          }.bind(this),
          800
        );
        vm.currentid = vm.id;
      } else {
        vm.getRadioData();
      }
      //get id from param
      //no param,thus initialize first item in radio list
    },
  },
};
</script>

<style scoped>
.mb_controller {
  overflow: hidden;
  margin-bottom: 80px;
}
.now_playing_title {
  font-size: 22px;
  font-weight: bold;
  line-height: 22px;
  text-align: left;
  color: #fab900;
  text-transform: capitalize;
}
.breadCrumbsWrapper {
  position: absolute;
  top: 88px;
  z-index: 1;
}
.player-position {
  width: 100%;
  max-width: 380px;
}
.playerWrapper {
  height: 52px;
  position: relative;
  width: 100%;
  max-width: 380px;
  overflow: hidden;
}
.playerAbsoluteDiv {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 5;
}

@media screen and (max-width: 768px) {
  .breadCrumbsWrapper {
    top: 10px;
  }
}
.radio-mobile-container {
  background: #000;
}
.radio-mobile-artwork {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 240px;
}
.radio-mobile-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  background: #000;
}
.radio-mobile-player {
  position: relative;
  height: fit-content;
  overflow: hidden;
}
</style>
